import { NgModule } from '@angular/core';
import { DeviceSelectModule } from './device-select/device-select.module';

@NgModule({
    imports: [
        DeviceSelectModule
    ],
    exports: [
        DeviceSelectModule
    ],
})
export class DeviceFilterModule { }
